import { useEffect } from 'react';
import { useRouterState } from '@tanstack/react-router';

/**
 * Hook to update document title based on current route (TanStack Router).
 */
export const useDocumentTitle = () => {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    const path = pathname;

    // Base title
    let title = 'Flowstate Automate';

    // Add page-specific titles
    if (path === '/admin' || path === '/admin/') {
      title = 'Flowstate Nexus: Admin - Flowstate Automate';
    } else if (path.startsWith('/admin') || path === '/dashboard' || path.startsWith('/dashboard/')) {
      title = 'Flowstate Nexus: Admin - Flowstate Automate';
    } else if (path === '/profile' || path.startsWith('/profile/')) {
      title = 'Flowstate Nexus: Personal - Flowstate Automate';
    }

    document.title = title;
  }, [pathname]);
};
